module.exports = __webpack_public_path__ + "static/media/github.ad052847.svg";